export default __webpack_public_path__ + "assets/ico_feed_edit-11ee13cf.svg";